module.exports = __webpack_public_path__ + "a36764134107d0fe6c80bc7fa696fb16.wav";